<aside
    class="modal-container"
    [ngClass]="{
        'translate-y-0 scale-100': active(),
        'translate-y-2/3 scale-0': !active(),
        'transition duration-200': animate(),
    }">
    <div
        class="relative z-50 flex max-h-full w-[90%] flex-col overflow-hidden rounded-xl bg-white shadow-xl md:max-h-[90vh] md:w-full md:max-w-4xl">
        <div class="flex flex-col gap-4 overflow-hidden p-8 md:flex-row">
            <div class="inline-block overflow-x-hidden overflow-y-auto">
                <h2>We use Cookies 🍪</h2>
                <div class="w-full">
                    <p>Hi there,</p>
                    <p class="py-2">
                        We use cookies that help this website to function and
                        also to track how you interact with our website. To
                        provide the best user experience please click "Accept"
                    </p>
                </div>
            </div>
            <div>
                <app-cta-button
                    type="button"
                    [additionalClasses]="['w-full mb-4']"
                    (onClick)="accept()">
                    Accept
                </app-cta-button>
                <app-cta-button
                    type="button"
                    [additionalClasses]="['w-full']"
                    (onClick)="decline()"
                    variant="secondary">
                    Decline
                </app-cta-button>
            </div>
        </div>
    </div>
</aside>
